import config from '../config';

class DashboardService {
  static async getDashboardMetrics(odmType = 'Bandwidth Upgrade/Downgrade') {
    try {
      const response = await fetch(`${config.apiUrl}/api/dashboard/metrics?odm_type=${encodeURIComponent(odmType)}`);
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }

  static async getStatusDistribution(odmType = 'Bandwidth Upgrade/Downgrade') {
    try {
      const response = await fetch(`${config.apiUrl}/api/dashboard/status-distribution?odm_type=${encodeURIComponent(odmType)}`);
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching status distribution:', error);
      throw error;
    }
  }

  static async getCountryDistribution(odmType = 'Bandwidth Upgrade/Downgrade') {
    try {
      const response = await fetch(`${config.apiUrl}/api/dashboard/country-distribution?odm_type=${encodeURIComponent(odmType)}`);
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching country distribution:', error);
      throw error;
    }
  }

  static async getOEDistribution(odmType = 'Bandwidth Upgrade/Downgrade') {
    try {
      const response = await fetch(`${config.apiUrl}/api/dashboard/oe-distribution?odm_type=${encodeURIComponent(odmType)}`);
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching OE distribution:', error);
      throw error;
    }
  }
}

export default DashboardService;